/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import viewicoSvg from '../../public/view-product.svg';
import editicoSvg from '../../public/edit-product.svg';
import eyeiconSvg from '../../public/eyeico.svg';

class ProductCertificatesApproval extends React.Component {
  render() {

    return (
      <div className="container pt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to='/'>Home</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Product and Certificates Aapproval</li>
          </ol>
        </nav>
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2">
          <div className="col-md-12 head-title">
            <h4>Aapproval, <span className="linear-title">Products</span></h4>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus
            </p>
          </div>
        </div>
        <div className="row p-3 mt-4 mb-3 rounded rounded-2 border">
          <div className="col-12">
            <ul className="nav nav-tabs alleventtabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="practitioner-poducts-tab" data-bs-toggle="tab" data-bs-target="#practitioner-poducts-pane" type="button" role="tab" aria-controls="practitioner-poducts-pane" aria-selected="true">Practitioner’s Products</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="practitioner-certifications-tab" data-bs-toggle="tab" data-bs-target="#practitioner-certifications-pane" type="button" role="tab" aria-controls="practitioner-certifications-pane" aria-selected="false">Practitioner’s Certifications</button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="practitioner-poducts-pane" role="tabpanel" aria-labelledby="practitioner-poducts" >
                <div className="row bg-light p-2 pt-4 mt-3 rounded rounded-2">
                  <div className="col-md-10">
                    <div className="fw-normal show-count">Showing 8 of 23 Products <b>Unapproved Products</b></div>
                  </div>
                  <div className="col-md-2 view-mode-btn text-end mb-3">
                    <Link to='/' className="btn" id="list3"> <i className="fa fa-list p-2 fs-4" aria-hidden="true"></i></Link>
                    <Link to='/' className="btn active_btn3" id="grid3"> <i className="fa fa-th p-2 fs-4" aria-hidden="true"></i></Link>
                  </div>
                  <div className="col-12">
                    <div className="row view-group" id="products3">
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-1.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn" data-bs-toggle="modal" data-bs-target="#productapproval">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-2.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-3.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-4.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-5.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-6.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-7.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3 item item3">
                        <div className="card p-3 product-card thumbnail">
                          <div className="img-event">
                            <img src={require('../../public/product-img-8.jpg')} className="img-fluid card-img-top rounded" alt="products" />
                          </div>
                          <div className="card-img-overlay">
                            <Link to='/' className="btn">
                              <img src={viewicoSvg} alt="view product" />
                            </Link>
                            <Link to='/' className="btn d-block">
                              <img src={editicoSvg} alt="edit product" />
                            </Link>
                          </div>
                          <div className="card-body px-0">
                            <h5 className="card-title">My Product Name
                              <span className="badge rounded-pill text-bg-light view-tag fw-normal float-end p-2">1287 Views</span></h5>
                            <span className="card-subtitle mb-2 text-dark"><i className="fa fa-inr" aria-hidden="true" /> 1,000</span> <span className="text-decoration-line-through text-muted mx-4"><i className="fa fa-inr" aria-hidden="true" /> 1,500</span>
                            <figure className="bg-white p-2 mt-3 pro-cap">
                              <blockquote className="blockquote pb-2 card-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed Lorem ipsum dolor sit amet,
                              </blockquote></figure>
                            <span className="card-text badge rounded rounded-4 text-bg-light pt-2 pb-2 w-100"><small className="text-muted fw-normal"><b>Added -</b> Sept, 2022</small><small className="text-muted fw-normal d-block"> <b>Last Updated -</b> Jan, 2023</small></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="practitioner-certifications-pane" role="tabpanel" aria-labelledby="practitioner-certifications">
                <div className="row mt-4">
                  <div className="col-12 mb-4">
                    <div className="fw-normal show-count">Showing 9 of 20 <b>unapproved certifications</b></div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <Link to="/" data-bs-toggle="modal" data-bs-target="#certificateapproval"><img src={eyeiconSvg} className="float-end" alt="view certifications" /></Link></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <img src={eyeiconSvg} className="float-end" alt="view certifications" /></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <img src={eyeiconSvg} className="float-end" alt="view certifications" /></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <img src={eyeiconSvg} className="float-end" alt="view certifications" /></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <img src={eyeiconSvg} className="float-end" alt="view certifications" /></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="card p-2 bg-secondary-subtle border-0 rounded rounded-4">
                      <div className="row">
                        <div className="col-md-1">
                          <span className="icon-shape fs-4 rounded-circle d-flex align-items-center justify-content-center mt-3">VN</span>
                        </div>
                        <div className="col-md-11">
                          <div className="card-body">
                            <h5 className="card-title fs-6 text-dark mb-0 pb-0">Dr Vivek’s Naturopathy <img src={eyeiconSvg} className="float-end" alt="view certifications" /></h5>
                            <p className="card-text mb-2">
                              <small className="text-dark">23th October 2024</small>
                            </p>
                            <p className="card-text">Medical Degree and Personel Id Card</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ---------------- Product Approval Popup ---------------- */}
        <div className="modal fade" id="productapproval" tabIndex="-1" aria-labelledby="productapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="productapprovalLabel">Preview Product for approval</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-12 p-3 mb-4 bg-light">
                    <h5>Product Approval</h5>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <div className=""><b>Registered -</b> <span>20 October 2022</span> | <b className="ml-15">Updated on -</b> <span>24 October 2022</span></div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group position-relative">
                          <input type="text" className="form-control pd-tb-675em pb-3" placeholder="Enter the comments here" name="proposeapprove" />
                        </div>
                      </div>
                      <div className="col-md-2 text-end mob-btn-col"><button type="button" className="btn theme-btn-fill pd-tb-675em border-2 w-100">Approve</button></div>
                      <div className="col-md-2 mob-btn-col"><button type="button" className="btn theme-btn-outline pd-tb-675em border-2 w-100">Disapprove</button></div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="box-zoom">
                      <div className="product-images">
                        <div className="picZoomer">
                          <img src={require('../../public/product-thumb-main.jpg')} className="img-fluid my_img" alt="gallery" />
                        </div>
                      </div>
                      <div className="zoom-thumb">
                        <ul className="piclist">
                          <li><img src={require('../../public/product-thumb-1.jpg')} alt="thumbnail" /></li>
                          <li><img src={require('../../public/product-thumb-2.jpg')} alt="thumbnail" /></li>
                          <li className="d-flex align-items-center justify-content-center upload-pics border-2 mob-ver">
                            <div className="upload-box">
                              <i className="fa fa-plus-circle fs-2" aria-hidden="true" ></i>
                              <input className="upload-btn" type="file" name="file" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h5>Dr Vivek’s Naturopathy<button type="button" className="btn bg-body-secondary rounded rounded-4 float-end"><i className="fa fa-share" aria-hidden="true" /> Share</button></h5>
                    <span className="text-primary d-block mb-2 fw-bold">10 more products from this seller</span>
                    <span className="badge rounded-pill text-bg-morelight fw-normal mt-4">Ayush’s Pick</span>
                    <h4 className="mt-4 text-dark">Isha Sanjeevini Instant Drink for Your Health (500 g)</h4>
                    <p className="mt-4 text-dark">
                      <b>About this product :</b>  dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>

                    <div className="mt-4 p-des">
                      <p className="fs-3 fw-bold text-dark mb-0 pb-0">
                        <i className="fa fa-inr" aria-hidden="true" /> 3,595
                      </p>
                      <span className="mt-2 d-block">Local taxes included (where applicable)</span>
                      <span className="mt-4 d-block text-dark fw-bold">Buy online below...</span>
                      <div className="mt-2">
                        <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 1</button> <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 2</button> <button type="button" className="btn btn-dark p-2 px-4"><i className="fa fa-link fs-4" aria-hidden="true" /> Link 3</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4 my-4 bg-dark-subtle highlighted-row p-3 rounded rounded-4">
                  <div className="col-md-6 border-end border-4 border-white px-4">
                    <b>Product Effective for...</b>
                    <p className="d-block mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>
                  </div>
                  <div className="col-md-6 px-4">
                    <b>Main Ingredients...</b>
                    <p className="d-block mt-2">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione
                      enim ea nam magnam eligendi repellendus pariatur
                      exercitationem aliquam commodi</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <p>
                      <b>Product Description</b>
                      <span className="mt-2 d-block">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur
                        exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis! Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit,
                        porro totam corporis ipsum ipsam quis!
                      </span>
                    </p>
                    <p>
                      <b>Legal Disclaimer</b>
                      <span className="mt-2 d-block">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur
                        exercitationem aliquam commodi quibusdam earum neque impedit, porro totam corporis ipsum ipsam quis! Lorem ipsum, dolor sit amet consectetur
                        adipisicing elit. Minus ratione enim ea nam magnam eligendi repellendus pariatur exercitationem aliquam commodi quibusdam earum neque impedit,
                        porro totam corporis ipsum ipsam quis!
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ---------------- Product Approval Popup End ---------------- */}

        {/* ---------------- Certificate Approval Popup ---------------- */}
        <div className="modal fade" id="certificateapproval" tabIndex="-1" aria-labelledby="certificateapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="certificateapprovalLabel">Preview Certifications for approval</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row mt-4">
                  <div className="col-12 p-3 mb-4 bg-light">
                    <h5>Doctor’s Professional Certification</h5>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <div className=""><b>Registered -</b> <span>20 October 2022</span> | <b className="ml-15">Updated on -</b> <span>24 October 2022</span></div>
                      </div>
                      <div className="col-md-8">
                        <div className="form-group position-relative">
                          <input type="text" className="form-control pd-tb-675em pb-3" placeholder="Enter the comments here" name="proposeapprove" />
                        </div>
                      </div>
                      <div className="col-md-2 text-end mob-btn-col"><button type="button" className="btn theme-btn-fill pd-tb-675em border-2 w-100">Approve</button></div>
                      <div className="col-md-2 mob-btn-col"><button type="button" className="btn theme-btn-outline pd-tb-675em border-2 w-100">Disapprove</button></div>
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <img src={require('../../public/pdfpreview.jpg')} className="img-fluid w-100" alt="pdf preview" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ---------------- Certificate Approval Popup End ---------------- */}
      </div>
    );
  }
}
export default ProductCertificatesApproval;